//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { CATALOG_SOURCE_ERROR } from '@apis/catalog-validation/catalogValidationModel';

export function selectCatalogFailureMessage(failureReason?: CATALOG_SOURCE_ERROR) {
  switch (failureReason) {
    case CATALOG_SOURCE_ERROR.INVALID_FEED_CREDENTIALS:
      return 'The login name or password you provided is incorrect.';
    case CATALOG_SOURCE_ERROR.INVALID_FEED_LOCATION:
      return 'We can\'t reach the URL you provided, please confirm that it is correct.';
    case CATALOG_SOURCE_ERROR.INVALID_FEED_PROTOCOL:
      return 'The protocol of the URL you provided is not supported, please provide a URL\
       with protocol: http, https, ftp, ftps, or sftp.';
    default:
      return 'Your catalog URL, login name, or password are incorrect.';
  }
}
